import $ from '@nuskin/nuskinjquery';
import {AuthenticationService, UserService} from '@nuskin/ns-account';
import {ConfigService, storage} from '@nuskin/ns-util';
import AdrService from './adr/AdrService';
import PriceType from './cart/priceType.js';

/**
 *
 * ShopContextService
 *
 * @namespace ShopContextService
 */
let ShopContextService = function() {
    let ECOM3_STORAGE_KEY = 'shopContext';

    let getEcom3Cookie = function() {
        return $.cookie(ECOM3_STORAGE_KEY);
    };

    let setEcom3Cookie = function(value) {
        $.cookie(ECOM3_STORAGE_KEY, value, {path:'/'});
    };

    let getPriceType = function(isAdr, _user) {
        let user = _user || UserService.getUser(),
            priceType,
            isRetail =  (!AuthenticationService.isLoggedIn() || !user || user.priceType == 'RTL' || user.isCustomer() || user.isGuest);

        if (isAdr || AdrService.isAdrOverride()) {

            if (isRetail) {
                priceType = PriceType.WADR;
            } else {
                //hardcoding months to 7 because only one market differentiates between wadwd and wadw in the cart for now -
                // if that changes will need to make a config
                if (AdrService.getAdrMonths(storage.getItem(storage.metadata.ADR_CURRENT_ID)) > 7 &&
                  ConfigService.getMarketConfig().adpManage.EligibleWADWD) {
                    priceType = PriceType.WADWD;
                } else {
                    priceType = PriceType.WADW;
                }
            }
        } else {
            if (isRetail) {
                priceType = PriceType.WRTL;
            } else {
                priceType = PriceType.WWHL;
            }
        }
        return priceType;
    };

    let showPsv = function(accountType) {
        let user,
            showPsv = false;

        if (!accountType) {
            user = UserService.getUser();
            accountType = user ? user.accountType : 0;
        }

        // Only show PSV for distributors
        if (accountType == 10) {
            showPsv = true;
        } else if (accountType == 30 && ConfigService.getMarketConfig().showPsvForPfc) {
            showPsv = true;
        }
        return showPsv;
    };

    return {
        /**
         * Gets Ecom3 cookie
         * @memberof ShopContextService
         * @example
         * ShopContextService.getEcom3Cookie()
         * @returns {object} ecom3Cookie
         */
        getEcom3Cookie: getEcom3Cookie,

        /**
         * Sets Ecom3 Cookie
         * @memberof ShopContextService
         * @example
         * ShopContextService.setEcom3Cookie(value)
         * @param {object} ecom3Object
         */
        setEcom3Cookie: setEcom3Cookie,

        /**
         * Returns price type
         * @memberof ShopContextService
         * @example
         * ShopContextService.getPriceType(isAdr, _buyer)
         * @returns {string} priceType
         */
        getPriceType: getPriceType,

        /**
         * Is show PSV enabled
         * @memberof ShopContextService
         * @example
         * ShopContextService.showPsv(accountType)
         * @returns {boolean} showPsv
         */
        showPsv: showPsv
    }
}();

export default ShopContextService;
